<a-button :disabled="!contractId" type="primary" @click="showModal"
  >源单导入</a-button
>

<!-- <a-modal
  v-model:visible="visible"
  width="1000px"
  :keyboard="false"
  :centered="true"
  :mask-closable="false"
  @ok="ok"
  @cancel="closeModal"
>
  <template #title>
    <span>选择工程量清单</span>
    <small class="text-grey ml10">选中仅对当前页有效</small>
  </template>
  
</a-modal> -->
